import React from 'react';
import SettingRow from 'flow/components/Setting/SettingRow';
import Toggle from 'flow/components/ui-components/Toggle';
import { Profile } from 'flow/types/Profile';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    profile: TypedMap<Profile>;
    profileState: boolean;
    handleToggle: (key: string, value: boolean) => void;
}

const ProfileToggleItem = ({ profile, profileState, handleToggle }: Props) => (
    <SettingRow
        cta={
            <Toggle
                value={profileState}
                onChange={(value: boolean) => {
                    handleToggle(profile.get('key'), value);
                }}
                text={profile.get('description')}
            />
        }
    >
        {profile.get('description')}
    </SettingRow>
);

export default ProfileToggleItem;
